import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect } from 'react'
import { PeopleFill } from 'react-bootstrap-icons'
import { SearchContext } from '../../../contexts/SearchContext'
import InfluencerItem from './InfluencerListParts/InfluencerItem'
import OrderSelect from './InfluencerListParts/OrderSelect'

export default observer(function InfluencersList() {
  const { searchState, search, authentications, totalCount, loading, hasMore, resetSearch } = useContext(SearchContext)

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.scrollY + window.innerHeight >= document.body.scrollHeight - 300
      if (nearBottom && !searchState.loading && searchState.authentications.length < searchState.totalCount) search.page += 1
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div className="mx-auto max-w-[1400px] px-8 pb-12">
      <div className="flex items-center justify-between py-6">
        <p className="text-sm text-rb-mat-grey dark:text-gray-400">
          <span className="text-lg font-bold text-rb-black dark:text-white">{totalCount.toLocaleString()}</span>
          <span className="ml-1.5">{totalCount === 1 ? 'influencer found' : 'influencers found'}</span>
        </p>
        <OrderSelect />
      </div>

      {!loading && authentications.length === 0 && (
        <div className="flex flex-col items-center gap-3 rounded-xl border-1 border-dashed border-rb-dash-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode py-16 text-center">
          <PeopleFill className="text-3xl text-rb-lighter-grey" />
          <p className="font-semibold text-rb-black dark:text-white">No influencers match your search</p>
          <p className="text-sm text-rb-mat-grey dark:text-gray-400">Try a different name or loosen the filters.</p>
          <button type="button" onClick={resetSearch} className="mt-1 rounded-lg border-1 border-rb-green px-4 py-2 text-sm font-semibold text-rb-green hover:bg-rb-soft-green dark:hover:bg-rb-green/10">
            Clear search and filters
          </button>
        </div>
      )}

      <div className="flex flex-col gap-3">
        {authentications.map(authentication => <InfluencerItem key={authentication.id} authentication={authentication} />)}
      </div>

      {authentications.length > 0 && (
        <p className="py-6 text-center text-sm text-rb-lighter-grey dark:text-gray-500">
          {loading ? 'Loading…' : hasMore ? `Showing ${authentications.length} of ${totalCount.toLocaleString()}` : 'You have reached the end of the list'}
        </p>
      )}
    </div>
  )
})
